import CategoryBlock from '../revamp/CategoryBlock'

import type { FC } from 'react'

const CategoryBlockV2: FC = () => {
  return <CategoryBlock maxRows={2} variant="v2" />
}

export default CategoryBlockV2
